"use client";

import React from "react";
import { useLocation } from "react-router-dom";
import styles from "./PaymentStatus.module.css";
import { ReactComponent as YelloAlert } from "../../assets/icons/YelloAlert.svg";
import { ReactComponent as AngelDown } from "../../assets/icons/AngelDown.svg";

import { StoreService } from "../../services/store-service";
import {
  bookTimeWithDetails,
  requestPaymentUrl,
} from "../../services/server-actions";
import { DateTime } from "ts-luxon";

const PaymentStatus: React.FC = () => {
  const location = useLocation();
  const partnerId = location.state?.partnerId;
  const reservation = location.state?.reservation;

  const getServiceById = (id: number) => {
    const categories = StoreService.GetData("categories") || [];
    return categories.find((c: any) => c.id === id);
  };

  const selectedService = reservation?.categoryId
    ? getServiceById(reservation.categoryId)
    : null;

  const handlePayment = async () => {
    if (!selectedService || !partnerId || !reservation) return;

    try {
      const paymentDeadline = Date.now() + 5 * 60 * 1000;
      localStorage.setItem("paymentDeadline", paymentDeadline.toString());

      const onDate = reservation.onDate
        ? DateTime.fromISO(reservation.onDate).toISODate()
        : "2025-04-10";

      const fromTime = reservation.fromTime
        ? DateTime.fromISO(reservation.fromTime).toISO()
        : "2025-04-10T14:00:00";

      const toTime = reservation.toTime
        ? DateTime.fromISO(reservation.toTime).toISO()
        : "2025-04-10T14:30:00";

      const categoryId = selectedService.id;

      const trackingNumber = await bookTimeWithDetails(
        onDate,
        fromTime,
        toTime,
        categoryId,
        partnerId
      );

      if (isNaN(Number(trackingNumber))) {
        throw new Error("کد پیگیری معتبر نیست.");
      }

      const paymentUrl = await requestPaymentUrl(Number(trackingNumber));

      const paymentWindow = window.open(
        paymentUrl,
        "_blank",
        "width=480,height=720"
      );

      if (!paymentWindow) {
        alert("مرورگر پاپ‌آپ را مسدود کرده است. لطفاً پاپ‌آپ را فعال کنید.");
      }
    } catch (error) {
      console.error("❌ خطا در رزرو تایم یا پرداخت:", error);
      alert("مشکلی در رزرو تایم یا پرداخت رخ داد. لطفاً دوباره تلاش کنید.");
    }
  };

  return (
    <div className={styles.paymentContainer}>
      {!selectedService ? (
        <div className={styles.statusBox}>
          <div className={styles.statusRow}>
            <p className={styles.statusText}>در انتظار پرداخت</p>
            <YelloAlert className={styles.warningIcon} />
          </div>
          <div className={styles.amountRow}>
            <p className={styles.amountText}>تومان ۵۰۰۰</p>
            <p className={styles.amountLabel}>مبلغ قابل پرداخت</p>
          </div>
        </div>
      ) : (
        <div className={styles.selectedServiceBox}>
          <div className={styles.serviceHeader}>
            <p className={styles.serviceTitle}>سرویس {selectedService.name}</p>
          </div>
          <div className={styles.amountRow}>
            <p className={styles.amountLabel}>مبلغ قابل پرداخت</p>
            <p className={styles.amountText}>۵۰۰۰ تومان</p>
          </div>
          <button className={styles.payButton} onClick={handlePayment}>
          <AngelDown className={styles.angelIcon} />
            رزرو وقت و پرداخت
          </button>
        </div>
      )}
    </div>
  );
};

export default PaymentStatus;
